import { useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import {
  hasAnalyticsConsent,
  subscribeToCookieConsentChanges,
} from '../../utils/cookieConsent';

const GatedAnalytics = () => {
  const [allowed, setAllowed] = useState(hasAnalyticsConsent);

  useEffect(() => {
    const sync = () => setAllowed(hasAnalyticsConsent());
    sync();
    return subscribeToCookieConsentChanges(sync);
  }, []);

  return allowed ? <Analytics /> : null;
};

export default GatedAnalytics;
